// extracted by mini-css-extract-plugin
export default {"ribbon":"upNext_ribbon__4H49o","playlistPromo":"upNext_playlistPromo__bTn8t","playlistPromoBtn":"upNext_playlistPromoBtn__P9afw"};